module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Y Black.25fc395c.png";